import { render, staticRenderFns } from "./ListBnLivraisonFour.vue?vue&type=template&id=13ecee50&"
import script from "./ListBnLivraisonFour.vue?vue&type=script&lang=js&"
export * from "./ListBnLivraisonFour.vue?vue&type=script&lang=js&"
import style0 from "./ListBnLivraisonFour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports